import { ASSET_PATHS } from '../../utils/assetPath';

import './RetryErrorIcon.css';

interface RetryErrorIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * RetryErrorIcon component
 *
 * Displays a retry error icon using the SVG from the public folder.
 * Used to indicate steps that have been completed but have errors requiring user updates.
 *
 * @example
 * <RetryErrorIcon />
 * <RetryErrorIcon size={32} ariaLabel="Action required" />
 */
function RetryErrorIcon({ className = '', size = 32, ariaLabel = 'Retry error' }: RetryErrorIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`retry-error-icon ${className}`}
      height={size}
      src={ASSET_PATHS.RETRY_ERROR_ICON}
      width={size}
    />
  );
}

export default RetryErrorIcon;
